"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHeader = void 0;
const utils_1 = require("@ganache/utils");
function makeHeader(raw, totalDifficulty) {
    return {
        parentHash: utils_1.Data.from(raw[0], 32),
        sha3Uncles: utils_1.Data.from(raw[1], 32),
        miner: utils_1.Data.from(raw[2], 20),
        stateRoot: utils_1.Data.from(raw[3], 32),
        transactionsRoot: utils_1.Data.from(raw[4], 32),
        receiptsRoot: utils_1.Data.from(raw[5], 32),
        logsBloom: utils_1.Data.from(raw[6], 256),
        difficulty: utils_1.Quantity.from(raw[7], false),
        number: utils_1.Quantity.from(raw[8], false),
        gasLimit: utils_1.Quantity.from(raw[9], false),
        gasUsed: utils_1.Quantity.from(raw[10], false),
        timestamp: utils_1.Quantity.from(raw[11], false),
        extraData: utils_1.Data.from(raw[12]),
        mixHash: utils_1.Data.from(raw[13], 32),
        nonce: utils_1.Data.from(raw[14], 8),
        totalDifficulty: utils_1.Quantity.from(totalDifficulty, false),
        baseFeePerGas: raw[15] === undefined ? undefined : utils_1.Quantity.from(raw[15], false),
        withdrawalsRoot: raw[16] === undefined ? undefined : utils_1.Data.from(raw[16], 32)
    };
}
exports.makeHeader = makeHeader;
//# sourceMappingURL=helpers.js.map